import {
  BulkDeleteCallable,
  BulkMoveCallable,
  CanvasFolderCallable,
  ConfirmTrashCallable,
  ContainerFileDropCallable,
  CreateWorkspaceCallable,
  CrossWorkspaceFileDropCallable,
  DeleteAutomationCallable,
  DeleteFolderCallable,
  EditWorkspaceCallable,
  FileRecordVersionHistoryCallable,
  LibraryAddModeCallable,
  NewFolderCallable,
  PublishedFileDeleteCallable,
  PublishFileRecordCallable,
  RenameCanvasCallable,
  RenameChatCallable,
  RenameFileRecordCallable,
  ShareCanvasCallable,
  ShareFileRecordCallable,
  ShareWorkspaceCallable,
} from "@/action-dialog/callables";
import { FileConflictResolverProvider } from "@/components/FileConflictResolver";

/**
 * Mounts react-call roots for imperative action dialogs. Place inside
 * QueryClientProvider (and other app providers) so callables inherit context.
 *
 * BulkMoveDialog needs FileConflictResolverProvider; these roots sit at App
 * level (outside WorkspaceLayout), so we wrap them here rather than relying
 * on the layout-scoped provider.
 */
export function ActionDialogRoots() {
  return (
    <FileConflictResolverProvider>
      <ConfirmTrashCallable />
      <CreateWorkspaceCallable />
      <EditWorkspaceCallable />
      <ShareWorkspaceCallable />
      <NewFolderCallable />
      <ContainerFileDropCallable />
      <CrossWorkspaceFileDropCallable />
      <LibraryAddModeCallable />
      <CanvasFolderCallable />
      <DeleteFolderCallable />
      <DeleteAutomationCallable />
      <BulkMoveCallable />
      <BulkDeleteCallable />
      <PublishedFileDeleteCallable />
      <RenameCanvasCallable />
      <RenameChatCallable />
      <RenameFileRecordCallable />
      <ShareCanvasCallable />
      <ShareFileRecordCallable />
      <PublishFileRecordCallable />
      <FileRecordVersionHistoryCallable />
    </FileConflictResolverProvider>
  );
}
